import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { EmployeeWeekOffUploadsDto } from "./employee-week-off-uploads-dto";

export class EmployeeWeekOffUploadsResponseModel extends GlobalResponseObject{
    data?: EmployeeWeekOffUploadsDto[];

    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EmployeeWeekOffUploadsDto[]){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}